import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { OrganizationContactSelectDialogStore } from './organization-contact-select-dialog.store';
import { BaseDialogComponent } from '../../../../../components/kit/base-dialog/base-dialog.component';
import { AppFormGroup } from '../../../../../utils/form.utils';
import { fb, routeParams } from '../../../../shared/shared.global-service';
import { contentGlobalSuccess } from '../../../content.error';
import { FormatPersonPipe } from '../../../../shared/pipes/format-person.pipe';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { InfiniteScrollStore } from '../../../../shared/store/common/infinite-scroll.store';
import { FilterBuilder } from '../../../helper/filter.builder';
import { PersonTypeEnum } from '@libs/types/src/common/enum/person-type.enum';
import { isInvalid } from '../../../../shared/helpers/validate';
import { getUsersFrag } from './organization-contact-select-dialog.query';

@Component({
    selector: 'app-contact-select-dialog',
    templateUrl: './organization-contact-select-dialog.component.html',
    styleUrls: ['./organization-contact-select-dialog.component.scss'],
    providers: [OrganizationContactSelectDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        FormatPersonPipe,
        SelectInputComponent,
    ],
})
export class OrganizationContactSelectDialogComponent extends BaseDialogComponent {
    public readonly store = inject(OrganizationContactSelectDialogStore);

    protected form = new AppFormGroup({
        userId: fb.control<string | null>(null, Validators.required),
    });

    public usersScroll = computed(() => {
        if (!this.organizationId) return null;

        return new InfiniteScrollStore(
            this.store.api.getUsers,
            FilterBuilder.filter({ organizationId: routeParams.organizationId() }),
            true,
            getUsersFrag,
        );
    });

    private organizationId: number | null = null;
    private centerId: number = 0;
    private type: PersonTypeEnum = PersonTypeEnum.CONTACT;

    constructor() {
        super();

        this.organizationId = this.dialogConfig.data.organizationId;
        this.centerId = this.dialogConfig.data.centerId;
        this.type = this.dialogConfig.data.type;
    }

    public override async save() {
        if (isInvalid(this.form)) return;

        if (this.form.value.userId) {
            this.store.api.selectOrganizationCenterPerson({
                centerId: this.centerId,
                type: this.type,
                userId: this.form.value.userId,
            }).then(() => {
                contentGlobalSuccess.next('common.updated');
                this.dialogRef.close(true);
            });
        }
    }
}
